import { render, staticRenderFns } from "./PendingPickupOrders.vue?vue&type=template&id=19511606&scoped=true&"
import script from "./PendingPickupOrders.vue?vue&type=script&lang=js&"
export * from "./PendingPickupOrders.vue?vue&type=script&lang=js&"
import style0 from "./PendingPickupOrders.vue?vue&type=style&index=0&id=19511606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19511606",
  null
  
)

export default component.exports